var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"its-tabs",style:(_vm.tabStyle)},_vm._l((_vm.tabs),function(tab,i){return _c('div',{key:'tab-' + i,staticClass:"its-tab",class:[tab.id === _vm.selectedTab.id ? 'active' : ''],style:({width: 100 / _vm.tabs.length + '%'}),on:{"click":function($event){return _vm.changeTab(tab)}}},[_vm._v(_vm._s(tab.mainTitle))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }